import produce from 'immer';
import {
    SET_USER_LANGUAGE,
    configurationReducerType,
    configurationActionType,
} from './ConfigurationTypes';
import {RESET_STORE} from '../../resources/constants/actionsTypes';

const language = window.location.pathname.split('/')[1];
const isManagedLocale = language => ['fr', 'en', 'de'].includes(language);
const initialState: configurationReducerType = {
    userLanguage: isManagedLocale(language) ? language : 'fr',
};

const configurationReducer = (
    state = initialState,
    action: configurationActionType,
) =>
    produce(state, draft => {
        switch (action.type) {
            case SET_USER_LANGUAGE:
                draft.userLanguage = action.payload.userLanguage;
                break;
            case RESET_STORE:
                draft = initialState;
                break;
            default:
                return state;
        }
    });

export default configurationReducer;
